import React from 'react';
import styles from './AdditionalInfoP.module.css';

const AdditionalInfoP = props => {
	return <p className={`${props.passOnClasses} ${styles.AdditionalInfoP}`}>{props.children}</p>
}

export default AdditionalInfoP;